import { ICart, IEmptyCart } from '@/src/modules/cart/ICart'

interface IUpdateData {
    cartData: ICart | IEmptyCart
    newDeliveries: any[]
    editingLineItemUuid: string
}

function updateExistingVirtualOrBrandedData({
    cartData,
    editingLineItemUuid,
    newDeliveries,
}: IUpdateData) {
    // get the existing delivery by line item
    const existingDeliveryIndex = cartData.cart_contents?.deliveries?.findIndex(
        (delivery) => {
            return delivery.line_items?.find(
                (li) => li.line_item_uuid === editingLineItemUuid
            )
        }
    )

    // update the existing delivery item
    cartData.cart_contents.deliveries[existingDeliveryIndex] = {
        ...newDeliveries[0],
    }
}

export default updateExistingVirtualOrBrandedData
